export enum CheckerStatus {
  PRESCAN,
  FAILED,
  PASSED,
}
